import { Component } from 'react';
import styles from '../SCSS/ClassroomDashboard.module.scss';
const courseUnits = [
  'Specials',
  'Self-Regulation',
  'Respect',
  'Gratitude',
  'Perseverance',
  'Empathy',
  'Teamwork',
  'Kindness',
  'Honesty',
  'Optimism',
  'Courage',
];
type Props = {
  selectedIndex: number;
  onUnitSelect: (arg0: number) => unknown;
};

class CourseUnitsHeader extends Component<Props> {
  generateUnitHeaderElement = () => {
    const outputElement = [];

    for (let i = 1; i < courseUnits.length; i += 1) {
      outputElement.push(
        <div
          className={`${this.props.selectedIndex === i ? styles.selected : styles.unselected}`}
          onClick={() => this.props.onUnitSelect(i)}
          key={i}
        >
          {courseUnits[i]}
        </div>,
      );
    }

    // special element 0, but rendered at the end
    outputElement.push(
      <div
        className={`${this.props.selectedIndex === 0 ? styles.selected : styles.unselected}`}
        onClick={() => this.props.onUnitSelect(0)}
        key={0}
      >
        {courseUnits[0]}
      </div>,
    );
    return outputElement;
  };

  render() {
    return <div className={styles.courseHeader}>{this.generateUnitHeaderElement()}</div>;
  }
}

export default CourseUnitsHeader;
